import script from "./UserCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserCard.vue?vue&type=script&setup=true&lang=ts"

import "./UserCard.vue?vue&type=style&index=0&id=77f62611&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77f62611"]])

export default __exports__